import { connect } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { uploadAvatar } from '../../../../../actions/avatar';

const mapStateToProps = (state: AppState) => {
  return {};
};

const mapDispatchToProps = { uploadAvatar };

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
